import { ENotificationTypes } from '../model/types';

export const IMPORTANT_TYPES: Record<ENotificationTypes, boolean> = {
	[ENotificationTypes.CUSTOM]: false,
	[ENotificationTypes.SOURCES_NOT_VERIFIED]: false,
	[ENotificationTypes.SOURCES_ON_VERIFICATION]: false,
	[ENotificationTypes.SOURCES_ON_MODERATION]: false,
	[ENotificationTypes.SOURCES_ACTIVE]: false,
	[ENotificationTypes.SOURCES_REJECTED]: false,
	[ENotificationTypes.SOURCE_BRAND_CREATED]: false,
	[ENotificationTypes.SOURCE_OFFER_CREATED]: false,
	[ENotificationTypes.SOURCE_OFFER_JOINED]: false,
	[ENotificationTypes.SOURCE_OFFER_REJECTED]: false,
	[ENotificationTypes.SOURCE_OFFER_STOPPED]: false,
	[ENotificationTypes.OFFER_INVITE]: false,
	[ENotificationTypes.BRAND_INVITE]: false,
	[ENotificationTypes.NEW_OFFERS]: false,
	[ENotificationTypes.NEW_OFFER]: false,
	[ENotificationTypes.RATE_CHANGES]: false,
	[ENotificationTypes.BALANCE_UPDATE]: false,
	[ENotificationTypes.BONUS_CREATED]: false,
	[ENotificationTypes.TELEGRAM]: false,
	[ENotificationTypes.BROKEN_LINK]: false,
};
